<template>
  <v-main class="px-3 px-md-8 py-5" v-if="!simple">
    <div class="fixed-alert" v-if="warning">
      <v-alert
        dense
        border="right"
        type="warning"
        icon="mdi-alert-outline"
        class="rounded-t-0 rounded-b"
        elevation="2"
      >
        {{ warning }}
      </v-alert>
    </div>
    <BreadCrumbs v-if="breadcrombs && false" :ckobNumber="ckobNumber" />
    <div class="prepend-text" v-if="prepend">{{ prepend }}</div>
    <div class="title-bar" :class="{ 'mb-5': !backBtn }">
      <div>
        <h1 class="main-title" :class="{ 'color-red': alert }">
          <div>
            <span v-html="title"></span>
            <TooltipInputHint
              :hintCode="hintCode"
              :max-width="800"
              direction="right"
            />
          </div>
          <div>{{ title2 }}</div>
        </h1>

        <h2 v-if="subtitle" class="main-subtitle mt-1" v-html="subtitle" />
        <div v-if="addInfo && !!addressText" class="mt-1 text-14">
          <address class="obiect-address">
            Lokalizacja: <span class="bold-500">{{ addressText }}</span>
          </address>
          <span class="obiect-function" v-if="objectFunction">
            Funkcja obiektu:<span class="bold-500"> {{ objectFunction }}</span>
          </span>
        </div>
      </div>
      <div>
        <slot name="header"></slot>
      </div>
    </div>
    <div v-if="backBtn" class="mt-4 mb-4">
      <v-btn color="primary" text style="margin-left: -12px;" @click="goBack">
        <v-icon left>mdi-arrow-left-thin</v-icon>
        {{ backBtnText }}
      </v-btn>
    </div>

    <v-container class="ma-0 pa-0" :fluid="fluid">
      <slot />
    </v-container>
  </v-main>
  <div v-else>
    <slot />
  </div>
</template>

<script>
import BreadCrumbs from "./BreadCrumbs.vue";
import TooltipInputHint from "./common/TooltipInputHint.vue";

export default {
  name: "PageContainer",
  components: { BreadCrumbs, TooltipInputHint },
  props: {
    title: { type: String, default: "" },
    title2: { type: String, default: "" },
    prepend: { type: String, default: "" },
    ckobNumber: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    fluid: { type: Boolean, default: true },
    alert: { type: Boolean, default: false },
    breadcrombs: { type: Boolean, default: false },
    backBtn: { type: Boolean, default: false },
    backBtnText: { type: String, default: "Wróć do poprzedniego widoku" },
    simple: { type: Boolean, default: false },
    backRoute: {
      type: [Object, null]
    },
    ckobInfo: {
      type: Object,
      default: () => ({})
    },
    addInfo: { type: Boolean, default: false },
    hintCode: { type: String, default: null },
    warning: { type: String, default: "" }
  },
  methods: {
    goBack() {
      if (this.backRoute) {
        this.$router.push(this.backRoute);
        return;
      }
      this.$router.back();
    },
    print() {
      window.print();
    }
  },
  computed: {
    addressText() {
      const address = this.ckobInfo?.title?.objectInfo?.addresses[0];
      if (!address) return "";
      const postalCode = address.postalCode || "";
      const city = address.townName?.city || "";
      const street = address.streetName?.street || "";
      const houseNumber = address.houseNumber?.number || "";
      return `${postalCode} ${city}, ${street} ${houseNumber}`;
    },
    objectFunction() {
      return this.ckobInfo?.objectFunction || "";
    }
  }
};
</script>
<style scoped lang="scss">
.main-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--c-primary);
  &.color-red {
    color: var(--c-red);
  }
}
.main-subtitle {
  font-weight: 800;
  font-style: normal;
  font-size: 1rem;
}
.obiect-address {
  font-style: normal;
}

.obiect-function {
  font-style: normal;
}

.title-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.prepend-text {
  color: var(--c-primary);
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 16px;
  margin-bottom: 17px;
}

.fixed-alert {
  position: fixed;
  top: 60px;
  right: 22px;
  padding: 3px 10px;
  // background: #f90;
  // color: #fff;
  //fb8c00
  z-index: 3;
  // width: 250px;
  border-radius: 3px;
}

@media print {
  .no-print {
    display: none;
  }
  .content {
    padding: 0 !important;
  }
}
</style>
